<template>
    <div>
        
        <PageTitle v-bind:title="title" v-bind:admin="false" />

        <div class="alert alert-danger" v-if="errors.load">
            {{ errors.load }}
        </div>
        <Loader v-if="loading" />
        <div v-else-if="data.length">


            <DepartmentsSlider1 v-bind:departments="data" />

            <table class="custom-table mt-4">
                <thead>
                    <tr class="custom-table__header">
                        <th class="custom-table__col--25">id</th>
                        <th>Наименование</th>
                        <th class="text-center">Кол-во опубликованных курсов</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in data" :key="item.id">
                        <td>{{ item.id }}</td>
                        <td>
                            <router-link :to="{ name: 'department_show', params: { id: item.id } }">{{ item.name }}</router-link>
                        </td>
                        <td class="text-center">
                            {{ item.courseCount }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/Loader'
import PageTitle from '@/components/PageTitle'
import DepartmentsSlider1 from '@/components/DepartmentsSlider1'
//import jQuery from 'jquery'
export default {
    data() {
        return {
            loading: true,
            data: [],
            errors: {load: ''},
            title: 'Кафедры',
        }
    },
   async mounted() {
       this.loadRecords()
    },
    methods: {
        async loadRecords() {
            this.errors.load = ''
            try {
                this.loading = true
                let response = await axios.get('departments')
                this.data = response.data.departments
                this.loading = false
            }
            catch (e) {
                this.errors.load = 'Ошибка при загрузке данных'
            }
        },



    },
    components: {
        Loader,
        PageTitle,
        DepartmentsSlider1,
    }
}
</script>


<style  scoped>


        .custom-table {
            width: 100%;
            overflow: hidden;
            border-collapse: collapse;
            border-radius: 30px;
            border-radius: 10px;
            box-shadow: 0 0  2px 1px #E4E7EB;         
        }


        .custom-table__col--10 {
            width: 10%;
        }

        .custom-table__col--25 {
            width: 25%;
        }
        
        .custom-table__col--50 {
            width: 50%;
        }

        .custom-table__col--75 {
            width: 75%;
        }


        .custom-table__header {
            border-radius: 10px;
            background-color: #F5F7FA;
        }
        .custom-table__header th {
            text-transform: uppercase;
            font-weight: 400;
            font-size: .8rem;
            color: #166086;
        }

        .custom-table th, .custom-table td {
            padding: 15px 20px;
            border-bottom: 1px solid hsl(214, 15%, 91%);
        }

        .custom-table__link {
            /* color: #0B4F71; */
        }
        .custom-table__button {
            width: 100%;
            color: #fff;
            background-color: #166086;
            padding: 6px 12px;
            border: none;
            border-radius: 10px;
        }

</style>